
import { openDB, type DBSchema } from 'idb';
import { type ContentPack, type SearchIndexPack, DB_NAME, STORE_NAME, META_STORE_NAME } from './manifest';

interface BibleDB extends DBSchema {
    [STORE_NAME]: {
        key: string;
        value: ContentPack | SearchIndexPack;
    };
    [META_STORE_NAME]: {
        key: string;
        value: any;
    };
}

export const getDB = async () => {
    return openDB<BibleDB>(DB_NAME, 1, {
        upgrade(db) {
            db.createObjectStore(STORE_NAME);
            db.createObjectStore(META_STORE_NAME);
        },
    });
};

export const savePack = async (key: string, data: any) => {
    const db = await getDB();
    // Using put to overwrite
    await db.put(STORE_NAME, data, key);
};

export const getPack = async (key: string) => {
    const db = await getDB();
    return db.get(STORE_NAME, key);
};

export const getInstalledVersion = async (): Promise<string | undefined> => {
    const db = await getDB();
    return db.get(META_STORE_NAME, 'manifest_version');
};

export const setInstalledVersion = async (version: string) => {
    const db = await getDB();
    await db.put(META_STORE_NAME, version, 'manifest_version');
};
